import CollectionManagersModal from './CollectionManagersModal.container'
export default CollectionManagersModal
